import React from "react";
import { motion } from "framer-motion";

// Certifications Data from your PDF
const CERTIFICATES = [
  {
    id: 1,
    title: "IATF 16949:2016",
    subtitle: "Automotive Quality Management",
    // Placeholder for a vertical certificate document
    image: "certificates/IATF.png",
  },
  {
    id: 2,
    title: "ISO 9001:2015",
    subtitle: "Quality Management System",
    image: "certificates/ISO 9001.png",
  },
  {
    id: 3,
    title: "ISO 14001:2015",
    subtitle: "Environmental Management",
    image: "certificates/ISO 14001.png",
  },
  {
    id: 4,
    title: "ISO 45001:2018",
    subtitle: "Occupational Health & Safety",
    image: "certificates/ISO 45001.png",
  },
  {
    id: 5,
    title: "Hyundai SQ Cert",
    subtitle: "Supplier Quality - Level A",
    image: "certificates/SQ Certificate.png",
  },
];

const CertificationsCarousel = ({ isDesktop, THEME }) => {
  return (
    <section
      id="certificates"
      style={{
        backgroundColor: "transparent",
        // padding: "100px 0",
        overflow: "hidden",
        position: "relative",
        // paddingLeft: isDesktop ? "280px" : "0",
      }}
    >
      {/* Section Header */}
      <div
        style={{
          maxWidth: "1400px",
          margin: "0 auto",
          padding: "0 24px 64px 24px",
          textAlign: "left",
        }}
      >
        <h3
          style={{
            color: THEME.colors.primary, // Red accent for this section
            fontSize: "14px",
            fontWeight: 800,
            textTransform: "uppercase",
            letterSpacing: "0.2em",
            marginBottom: "16px",
          }}
        >
          Quality & Compliance
        </h3>
        <h2
          style={{
            color: "#09090b",
            fontSize: "42px",
            fontWeight: 900,
            textTransform: "uppercase",
            margin: 0,
            maxWidth: "800px",
            lineHeight: 1.1,
          }}
        >
          Certified for Excellence. <br />
          <span style={{ color: "#a1a1aa" }}>Approved for Safety.</span>
        </h2>
      </div>

      {/* Carousel Track */}
      <div
        style={{
          display: "flex",
          position: "relative",
          width: "100%",
          // Fade mask on edges
          maskImage: isDesktop
            ? "linear-gradient(to right, transparent, black 10%, black 90%, transparent)"
            : "none",
          WebkitMaskImage: isDesktop
            ? "linear-gradient(to right, transparent, black 10%, black 90%, transparent)"
            : "none",
        }}
      >
        <CertTrack items={CERTIFICATES} THEME={THEME} />
        <CertTrack items={CERTIFICATES} THEME={THEME} />
      </div>
    </section>
  );
};

const CertTrack = ({ items, THEME }) => {
  return (
    <motion.div
      animate={{ x: ["0%", "-100%"] }}
      transition={{
        ease: "linear",
        duration: 40, // Slower speed for reading certificates
        repeat: Infinity,
      }}
      style={{
        display: "flex",
        flexShrink: 0,
        gap: "48px", // Space between cards
        paddingRight: "48px",
        minWidth: "100%",
      }}
    >
      {items.map((cert, index) => (
        <div
          key={`${cert.id}-${index}`}
          style={{
            display: "flex",
            flexDirection: "column",
            width: "300px", // Fixed width for certificate card
            flexShrink: 0,
            cursor: "pointer",
            group: "group", // for hover effects
          }}
        >
          {/* Certificate Image Frame */}
          <div
            style={{
              width: "100%",
              height: "420px",
              // backgroundColor: "#f4f4f5", // Zinc 100
              // border: "1px solid #e4e4e7", // Zinc 200
              padding: "16px", // Inner padding like a frame
              marginBottom: "24px",
              position: "relative",
              transition: "transform 0.3s ease, box-shadow 0.3s ease",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "translateY(-10px)";
              // e.currentTarget.style.boxShadow =
              //   "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "translateY(0)";
              // e.currentTarget.style.boxShadow = "none";
            }}
          >
            <img
              src={cert.image}
              alt={cert.title}
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
                // boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1)", // Shadow on the paper itself
              }}
            />

            {/* Badge Overlay */}
            <div
              style={{
                position: "absolute",
                top: "24px",
                right: "24px",
                backgroundColor: THEME.colors.primary,
                color: "white",
                padding: "4px 8px",
                fontSize: "10px",
                fontWeight: "bold",
                textTransform: "uppercase",
                letterSpacing: "0.1em",
              }}
            >
              Certified
            </div>
          </div>

          {/* Text Content */}
          <div style={{ textAlign: "center" }}>
            <h4
              style={{
                fontSize: "18px",
                fontWeight: 800,
                color: "#09090b",
                margin: "0 0 8px 0",
                textTransform: "uppercase",
              }}
            >
              {cert.title}
            </h4>
            <p
              style={{
                fontSize: "14px",
                color: "#71717a", // Zinc 500
                margin: 0,
                lineHeight: 1.5,
              }}
            >
              {cert.subtitle}
            </p>
          </div>
        </div>
      ))}
    </motion.div>
  );
};

export default CertificationsCarousel;
